var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LeadStatusesPage',{attrs:{"title":"Status concluído","description":"Status que definem uma lead como concluída","param-id":"lead_statuses_completed"}})
}
var staticRenderFns = []

export { render, staticRenderFns }